import { DashboardT } from 'business/definitions';
import { useGetConvertedSlug } from 'hooks/useGetConvertedSlug';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { HttpError, RQAPICallWithData } from 'store/APIClient';
import { useSelector } from 'store/hooks';
import { buildPublicTokenSearchParams } from 'helpers/urlHelpers';

const useGetDashboard = (
    dashboardSlug: string | null | undefined,
    publicToken?: string,
    notifyError: boolean = true,
): UseQueryResult<DashboardT, HttpError> => {
    const { isAuthenticated } = useSelector((state) => state.vision);

    const convertedSlug = useGetConvertedSlug(dashboardSlug);
    const query = !isAuthenticated
        ? `?${buildPublicTokenSearchParams(publicToken)}`
        : '';

    return useQuery({
        queryKey: ['getDashboard', convertedSlug, query],
        queryFn: async () => {
            const response = await RQAPICallWithData<DashboardT>({
                endpoint: `explore/dashboard/${convertedSlug}${query}`,
                method: 'GET',
            });
            return response.content.data;
        },
        enabled: !!dashboardSlug,
        meta: {
            useGlobalOnError: notifyError,
        },
    });
};

export default useGetDashboard;
